import { render, staticRenderFns } from "./member-type.vue?vue&type=template&id=342fe704"
import script from "./member-type.vue?vue&type=script&lang=ts"
export * from "./member-type.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports